import { api } from "..";
import { ProviderProfileRecordType } from "../../../provider/profileBuilder/section-data";
import { ProviderProfileVersion } from "./types";

const SectionAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getAllRecordsByProviderId: build.query<
      { [key: string]: ProviderProfileRecordType[] },
      { providerId: string }
    >({
      query: ({ providerId }) => `/provider/${providerId}/dynamicprofile`,
      providesTags: ["ProviderProfile"],
    }),
    getAllRecordsByProviderAndSectionId: build.query<
      ProviderProfileRecordType[],
      { providerId: string; sectionId: String }
    >({
      query: ({ providerId, sectionId }) =>
        `/providers/${providerId}/sections/${sectionId}`,
      providesTags: ["ProviderProfile"],
    }),
    getRecordsByProviderAndRecordId: build.query<
      ProviderProfileRecordType[],
      { providerId: string; recordId: String }
    >({
      query: ({ providerId, recordId }) =>
        `/providers/${providerId}/records/${recordId}`,
      providesTags: ["ProviderProfile"],
    }),
    addProviderSectionRecord: build.mutation<
      void,
      { providerId: string; sectionId: string; data: ProviderProfileRecordType }
    >({
      query: ({ providerId, sectionId, data }) => ({
        url: `/providers/${providerId}/sections/${sectionId}/records/add`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProviderProfile"],
    }),
    editProviderSectionRecord: build.mutation<
      void,
      { providerId: string; recordId: string; data: ProviderProfileRecordType }
    >({
      query: ({ providerId, recordId, data }) => ({
        url: `/providers/${providerId}/records/${recordId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ProviderProfile"],
    }),
    updateProviderProfileRecord: build.mutation<
      void,
      {
        providerID: string;
        sectionId: string;
        recordId: string;
        isVersioned: boolean;
        data: ProviderProfileRecordType;
      }
    >({
      query: ({
        providerID,
        sectionId,
        recordId,
        isVersioned = false,
        data,
      }) => ({
        url: `/providers/${providerID}/sections/${sectionId}/records/${recordId}?isVersioned=${isVersioned}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ProviderProfile"],
    }),
    deleteProviderProfileRecord: build.mutation<
      void,
      { providerId: string; recordId: string }
    >({
      query: ({ providerId, recordId }) => {
        return {
          url: `/providers/${providerId}/records/${recordId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ProviderProfile"],
    }),
    getProviderProfileVersions: build.query<
      ProviderProfileVersion[],
      { recordId: string }
    >({
      query: ({ recordId }) => `/providerprofile/${recordId}/versions`,
      providesTags: ["ProviderProfile"],
    }),
  }),
});

export const {
  useGetAllRecordsByProviderIdQuery,
  useGetAllRecordsByProviderAndSectionIdQuery,
  useGetRecordsByProviderAndRecordIdQuery,
  useAddProviderSectionRecordMutation,
  useEditProviderSectionRecordMutation,
  useUpdateProviderProfileRecordMutation,
  useDeleteProviderProfileRecordMutation,
  useGetProviderProfileVersionsQuery,
} = SectionAPI;
